import React from 'react';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

const MuteButton = ({setIsMuted, isMuted, icons}) => {
	return (
		<Button
			classNames="mute-button"
			onClick={() => {
				setIsMuted(!isMuted);
			}}
		>
			{isMuted
				? <Icon
					name={icons.muted}
					height={icons.height}
					width={icons.width}
				/>
				: <Icon
					name={icons.unmuted}
					height={icons.height}
					width={icons.width}
				/>
			}
		</Button>
	);
};

export default MuteButton;
